import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// 1️⃣ Initialize React plugin and AppInsights
const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_AZURE_APP_INSIGHT_STRING_CONNECTION,
    extensions: [reactPlugin],
    enableAutoRouteTracking: true, // auto track route changes
    enableCorsCorrelation: true, // better AJAX tracking across domains
    enableAjaxErrorStatusText: true, // capture AJAX error status text
  },
});

// Add global telemetry initializer
appInsights.addTelemetryInitializer((env) => {
  Object.assign(env.tags ?? {}, {
    'ai.cloud.role': process.env.REACT_APP_SERVICE_NAME,
    'ai.cloud.roleInstance': window.location.hostname,
  });
  return true;
});

// Load AppInsights
appInsights.loadAppInsights();

// Track initial page view manually to ensure first render is captured
appInsights.trackPageView();

// 2️⃣ HOC for component tracking
export const WithAITracking = <P extends object>(Component: React.ComponentType<P>): React.ComponentType<P> =>
  withAITracking(reactPlugin, Component);

// 3️⃣ Optional: React Router v6 hook to track route changes (redundant if enableAutoRouteTracking works, but ensures reliability)
export const useTrackRouteChanges = () => {
  const location = useLocation();
  useEffect(() => {
    appInsights.trackPageView({ name: location.pathname });
  }, [location]);
};

export default WithAITracking;

export { reactPlugin, appInsights };
